<template>
  <div class="pa-4">
    <v-layout row wrap>
      <v-flex md6>
        <label for="">Title</label>
        <v-text-field v-model="item.body.question" outline></v-text-field>
      </v-flex>
      <v-flex md6>
        <label for="">locale</label>
        <v-autocomplete
          v-model="item.body.locale"
          :items="langIso"
          item-text="name"
          item-value="code"
          outline
          solo
          label="Search Languages"
        >
        </v-autocomplete>
      </v-flex>
      <v-flex md12>
        <label for="">Answer</label>
        <v-textarea v-model="item.body.answer" outline> </v-textarea>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import langIso from "../../../../utils/lang-iso";
export default {
  name: "faqItem",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      langIso,
    };
  },
  methods: {
    async updateFaq() {
      this.$store.dispatch("setSavingStatus", true);
      await this.$http.put(`/bot_objects/faqs/${this.item.id}`, this.item);
    },
  },
  watch: {
    item: {
      async handler() {
        await this.updateFaq();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
